import { render, staticRenderFns } from "./SocialShareButtons.vue?vue&type=template&id=655dacbc&"
import script from "./SocialShareButtons.vue?vue&type=script&lang=js&"
export * from "./SocialShareButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports